import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy-page">
            <h1>Privacy Policy</h1>
            <div className="content">
                {/* Here you will add the text for your privacy policy */}
                <article>
    <h1>Privacy Policy for [Your Company Name]</h1>

    <p><strong>Last Updated: [Date]</strong></p>

    <h2>1. Introduction</h2>
    <p>Welcome to [Your Company Name]. We respect your privacy and are committed to protecting your personal data. This Privacy Policy will inform you as to how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.</p>

    <h2>2. Information Collection</h2>
    <p>We may collect, use, store, and transfer different kinds of personal data about you, which we have grouped together as follows:</p>
    <ul>
        <li><strong>Identity Data</strong>: includes first name, last name, username or similar identifier.</li>
        <li><strong>Contact Data</strong>: includes email address and telephone numbers.</li>
        <li><strong>Technical Data</strong>: includes internet protocol (IP) address, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system, and platform, and other technology on the devices you use to access this website.</li>
    </ul>
    <p>We use different methods to collect data from and about you including through direct interactions (when you fill out forms on our site) and automated technologies or interactions (as you interact with our website, we may automatically collect Technical Data about your equipment, browsing actions, and patterns).</p>

    <h2>3. Use of Information</h2>
    <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
    <ul>
        <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
        <li>Where it is necessary for our legitimate interests and your interests and fundamental rights do not override those interests.</li>
        <li>Where we need to comply with a legal obligation.</li>
    </ul>

    <h2>4. Sharing of Information</h2>
    <p>We may have to share your personal data with external third parties, including service providers, regulators, and other entities in the group.</p>

    <h2>5. Data Security</h2>
    <p>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered, or disclosed.</p>

    <h2>6. Your Rights</h2>
    <p>Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to request access, correction, erasure, restriction, transfer, to object to processing, to data portability, and the right to withdraw consent.</p>

    <h2>7. Data Retention</h2>
    <p>We will only retain your personal data for as long as necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements.</p>

    <h2>8. Changes to This Privacy Policy</h2>
    <p>We keep our Privacy Policy under regular review. This version was last updated on [Date]. Historic versions can be obtained by contacting us.</p>

    <h2>9. Contact Us</h2>
    <p>For any questions or requests regarding this Privacy Policy and our privacy practices, contact us at: [Your Contact Information].</p>
</article>

            </div>
        </div>
    );
}

export default PrivacyPolicy;
